import axios from "axios";

export default {
    namespaced: true,
    state: {
        lc_list:[],
        lc_info:{}
    },
    getters:{
        lc_list(state){
            return state.lc_list
        },
        lc_info(state){
            return state.lc_info
        }
    },  
    mutations:{
        SET_LC_LIST (state, payload) {
            state.lc_list = payload
        },
        SET_LC_INFO (state, payload) {
            state.lc_info = payload
        }
    },
    actions:{
       async getLcList(context,param){
        const response = await axios.get('/api/fetchLC',{
            headers:{
              'Authorization':`Bearer ${param.token}`,
              "Access-Control-Allow-Headers": "*",
               "Access-Control-Allow-Method" : "*",
               "Access-Control-Allow-Origin": "*",
               "Access-Control-Allow-Credentials": "*",
            }
          });

            if(response.status == 200){

                context.commit('SET_LC_LIST',response.data)
            }
       }
    }
}